/* eslint-disable import/prefer-default-export */
import {
  NetworkTableTab,
  NetworkTileType
} from '@src/endpoints/services/graphQueryMgr.service'
import { ResourceTypeEnum } from '@src/endpoints/services/commonHdr.service'

export type NetworkTileConfiguration = {
  tile: NetworkTileType
  tableTab?: NetworkTableTab
}

export type NetworkTilesConfiguration = {
  [key: string]: NetworkTileConfiguration
}

export enum NetworkTiles {
  IAM = 'IAM',
  AuditTrail = 'AuditTrail',
  Violations = 'Violations',
  Networking = 'Networking',
  Objects = 'Objects',
  Roles = 'Roles'
}

export enum NetworkTileCounter {
  total = 'total',
  used = 'used'
}

export const NetworkTileNames = {
  [NetworkTiles.IAM]: 'IAM',
  [NetworkTiles.AuditTrail]: 'Audit Trail',
  [NetworkTiles.Violations]: 'Alerts',
  [NetworkTiles.Networking]: 'Networking',
  [NetworkTiles.Objects]: 'Objects',
  [NetworkTiles.Roles]: 'Roles'
}

export const NetworkTileConfiguration: NetworkTilesConfiguration = {
  [NetworkTiles.IAM]: {
    tile: NetworkTileType.TILE_NETWORK_IAM,
    tableTab: NetworkTableTab.TABLE_TAB_IAM_USER
  },
  [NetworkTiles.Networking]: {
    tile: NetworkTileType.TILE_NETWORK_NETWORKING,
    tableTab: NetworkTableTab.TABLE_TAB_NETWORKING_INSTANCES
  },
  [NetworkTiles.Objects]: {
    tile: NetworkTileType.TILE_NETWORK_OBJECTS
  },
  [NetworkTiles.Roles]: {
    tile: NetworkTileType.TILE_NETWORK_ROLES
  }
}

export const getConfigFromType = (
  type: ResourceTypeEnum
): NetworkTileConfiguration =>
  type === ResourceTypeEnum.INSTANCE
    ? NetworkTileConfiguration[NetworkTiles.Objects]
    : NetworkTileConfiguration[NetworkTiles.IAM]
